import { createLocale, dateUzUZ, uzUZ } from 'naive-ui';

/**
 * Naive UI'ning o'z matnlari (bo'sh maydon placeholder'i, sana tanlagich,
 * «ma'lumot yo'q» va h.k.). Avval `enUS` edi — maydonlarda «Please Input» /
 * «Please Select» chiqardi. Naive'ning `uzUZ` asos qilingan, lekin unda tutuq
 * belgisi o'rniga backtick (`Ma\`lumotlar yo\`q`) va bir nechta noto'g'ri
 * tarjima bor — shular `uz.ts` dagi imlo bilan (‘ va ’) shu yerda tuzatiladi.
 */
export const naiveLocale = createLocale(
  {
    Cascader: { placeholder: 'Tanlang' },
    Select: { placeholder: 'Tanlang' },
    Input: { placeholder: 'Kiriting' },
    InputNumber: { placeholder: 'Kiriting' },
    TimePicker: { placeholder: 'Vaqtni tanlang' },
    DatePicker: {
      selectTime: 'Vaqtni tanlang',
      selectDate: 'Sanani tanlang',
      datePlaceholder: 'Sanani tanlang',
      datetimePlaceholder: 'Sana va vaqtni tanlang',
      monthPlaceholder: 'Oyni tanlang',
      yearPlaceholder: 'Yilni tanlang',
      quarterPlaceholder: 'Çorakni tanlang',
      weekPlaceholder: 'Haftani tanlang',
      startDatePlaceholder: 'Boşlanğiç sana',
      endDatePlaceholder: 'Tugaş sanasi',
      startDatetimePlaceholder: 'Boşlanğiç sana va vaqt',
      endDatetimePlaceholder: 'Tugaş sanasi va vaqti',
      startMonthPlaceholder: 'Boşlanğiç oy',
      endMonthPlaceholder: 'Tugaş oyi',
    },
    Empty: { description: 'Ma’lumot yöq' },
    Pagination: { goto: 'Ötiş' },
    DynamicTags: { add: 'Qöşiş' },
    Image: {
      tipCounterclockwise: 'Soat miliga teskari',
      tipClockwise: 'Soat mili böyiça',
      tipZoomOut: 'Kiçraytiriş',
      tipZoomIn: 'Kattalaştiriş',
      tipOriginalSize: 'Asl ölçamga qaytiş',
    },
  },
  uzUZ,
);

export const naiveDateLocale = dateUzUZ;
